import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-XXSmall",
        "text-XSmall",
        "text-Small",
        "text-Medium",
        "text-Large",
        "text-XLarge",
        "text-XXLarge",
        "text-XXXLarge",
      ],
    },
  },
});

/**
 * @deprecated `@/lib/tailwind-variants` の `cn` を使用してください。
 */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
